import { API_APPS } from '@/api/config'
import authApi from '@/api/auth/authApi'
import confirmationApi from '@/api/confirmation/confirmationApi'
import AuthUser from '@/classes/auth/AuthUser'
import Profile from '@/classes/auth//Profile'
import FormDescriptor from '@/classes/form/FormDescriptor'
import FormData from '@/classes/form/FormData'

const state = {
  authUser: new AuthUser(),
  authProfiles: [],
  isLoggedIn: AuthUser.isLoggedIn(),
  formDescriptors: [],
  formDatas: []
}

const mutations = {
  setIsLoggedIn: (state) => {
    state.isLoggedIn = AuthUser.isLoggedIn()
  },
  setAuthUser: (state, data) => {
    state.authUser.loginAuthUser(data)
  },
  setAuthProfiles: (state, data) => {
    state.authProfiles = Profile.asProfile(data)
  },
  setLoggedOut: (state) => {
    state.authUser.logoutAuthUser()
  },
  setStateFormDescriptorsLogin: (state, data) => {
    state.formDescriptors = FormDescriptor.asFormDescriptors(data)
  },
  setStateFormDatasLogin: (state, data) => {
    state.formDatas = FormData.initiateFormDatas(state.formDescriptors)
    FormData.loadInitialFormDatas(data, state.formDatas)
    FormDescriptor.checkFormDescriptorsDependencies(state.formDescriptors, state.formDatas)
  }
}

const actions = {
  authenticateUser ({ commit }, data) {
    commit('setAuthUser', data)
    commit('setIsLoggedIn')
  },
  authentication ({ commit }, data) {
    commit('setAuthUser', data)
    let path = data.path || '/'
    if (AuthUser.isCustomer()) {
      if (state.authUser.isAuditor() || state.authUser.isAdministrator() || state.authUser.isManager()) {
        window.location.replace(API_APPS.CUSTOMER + data.path)
      } else {
        window.location.replace(API_APPS.CUSTOMER + '/')
      }
    } else if (AuthUser.isAuditor()) {
      window.location.replace(API_APPS.AUDITOR + path)
    } else if (AuthUser.isAdministrator()) {
      window.location.replace(API_APPS.ADMINISTRATOR + path)
    } else if (AuthUser.isManager()) {
      window.location.replace(API_APPS.MANAGER + path)
    } else if (AuthUser.isHR()) {
      window.location.replace(API_APPS.HR + path)
    } else {
      commit('setLoggedOut')
      window.location.replace(API_APPS.PUBLIC + '/')
    }
  },
  setupLoginForm ({ commit }) {
    return authApi.getLoginForm().then((response) => {
      let data = response.data
      commit('setStateFormDescriptorsLogin', [data])
      commit('setStateFormDatasLogin', [])
      return true
    }).catch((err) => {
      throw err
    })
  },
  loginUser ({ commit, dispatch }, requestData) {
    return authApi.loginUser(requestData.serializedData).then((response) => {
      dispatch('authentication', response.data)
      commit('setIsLoggedIn')
    }).catch((err) => {
      throw err
    })
  },
  logoutUser ({ commit }, path = '') {
    return authApi.logoutUser().then((response) => {
      commit('setLoggedOut')
      commit('setIsLoggedIn')
      window.location.replace(API_APPS.PUBLIC + '/' + path)
    }).catch((err) => {
      commit('setLoggedOut')
      commit('setIsLoggedIn')
      console.error(err)
      window.location.replace(API_APPS.PUBLIC + '/' + path)
    })
  },
  switchProfile ({ dispatch }, routeData) {
    return authApi.switchProfile(routeData.userId, routeData.profileType).then((response) => {
      response.data.path = routeData.path
      dispatch('authentication', response.data)
    }).catch((err) => {
      throw err
    })
  },
  resetProfile ({ dispatch }, path) {
    return authApi.resetProfile(path).then((response) => {
      response.data.path = path
      dispatch('authentication', response.data)
    }).catch((err) => {
      throw err
    })
  },
  setupResetPasswordForm ({ commit }) {
    return authApi.getResetPasswordForm().then((response) => {
      let data = response.data
      commit('setStateFormDescriptorsLogin', [data])
      commit('setStateFormDatasLogin', [])
      return true
    }).catch((err) => {
      throw err
    })
  },
  saveResetPasswordForm ({ commit }, requestData) {
    return authApi.postResetPasswordForm(requestData.serializedData).then((response) => {
      return response
    }).catch((err) => {
      throw err
    })
  },
  setupResetPasswordSSNForm ({ commit }) {
    return authApi.getResetPasswordSSNForm().then((response) => {
      let data = response.data
      commit('setStateFormDescriptorsLogin', [data])
      commit('setStateFormDatasLogin', [])
      return true
    }).catch((err) => {
      throw err
    })
  },
  saveResetPasswordSSNForm ({ commit }, requestData) {
    return authApi.postResetPasswordSSNForm(requestData.serializedData).then((response) => {
      return response
    }).catch((err) => {
      throw err
    })
  },
  setupResetPasswordConfirmationForm ({ commit }, code) {
    return confirmationApi.getResetPasswordConfirmationForm(code).then((response) => {
      let data = response.data
      commit('setStateFormDescriptorsLogin', [data])
      commit('setStateFormDatasLogin', [])
      return true
    }).catch((err) => {
      throw err
    })
  },
  saveResetPasswordConfirmationForm ({ commit }, requestData) {
    return confirmationApi.postResetPasswordConfirmationForm(requestData.data.code, requestData.serializedData).then((response) => {
      return response
    }).catch((err) => {
      throw err
    })
  },
  clearData ({ commit }) {
    commit('setStateFormDescriptorsLogin', [])
    commit('setStateFormDatasLogin', [])
  }
}

export default {
  state,
  mutations,
  actions
}
